<template>
  <div
    v-if="date"
    class="d-flex flex-column justify-content-center align-items-center"
  >
    <p
      v-if="
        $moment().format('jYY-jMM-jDD') !== $moment(date).format('jYY-jMM-jDD')
      "
      class="text-primary"
    >
      {{ $moment(date).format('jD jMMMM') }}
    </p>
    <p v-else class="text-primary">امروز</p>
    <p style="color:#9a9a9a ; font-size:.9rem">{{ date | time }}</p>
  </div>
  <p v-else class="mb-0" style="color:#9a9a9a ; font-size:.9rem">---</p>
</template>

<script>
export default {
  name: 'DateTimeDisplay',
  props: {
    date: { type: String, default: '' },
    type: { type: String, default: 'default' }
  }
}
</script>
